import React from 'react';


interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  size: number;
}

export default class Image extends React.Component<
  Props
> {
  public render() {
    const { size, ...restProps } = this.props;
    return <img {...this.props} style={size? {width: (size*0.5)+'px'}: {}} />;
  }
}
